// 统一的异步 job 轮询(free-tools 重转换:刺绣数字化 / 大视频 / CAD / RAW→DNG)。
// 旧实现各处 120×1.5s(实测墙钟 ~180–300s,因每轮还含 fetch 延迟)。但后端这些转换真实耗时
// 190–300s(容器子进程上限:视频 240–300s、office 180–200s、dng 180s),且结果本就写进 R2 ——
// 前端在 180s 就断轮询 → 误报 async_pending(AE 审计:png→pes/png→dst/mov→mp4/psd→dwg 等,后端其实做成了)。
// 这里按"时间预算 + 退避"轮询:前 60s 每 1.5s,之后每 3s,默认上限 7.5 分钟,覆盖后端最慢完成时间。
// 返回最终 job 对象(status=done/error);到上限仍未完成 → 返回最后一次看到的(通常 pending),调用方按超时处理。

function nowMs() {
  return typeof performance !== "undefined" && performance.now ? performance.now() : 0;
}

export async function pollJob(jobId, { onTick, maxMs = 450000 } = {}) {
  let job = null;
  const t0 = nowMs();
  while (nowMs() - t0 < maxMs) {
    const elapsed = nowMs() - t0;
    await new Promise((r) => setTimeout(r, elapsed < 60000 ? 1500 : 3000));
    try {
      const jr = await fetch("/api/free-tools/job/" + encodeURIComponent(jobId), { cache: "no-store" });
      job = await jr.json();
    } catch (_) {
      continue;
    }
    if (onTick) { try { onTick(job, nowMs() - t0); } catch (_) { /* ignore */ } }
    if (job && (job.status === "done" || job.status === "error")) return job;
  }
  return job;
}

// 等待期间给用户的"仍在处理"提示(按已等时长升级),避免 7 分钟干等无反馈。
export function jobWaitMsg(ms) {
  if (ms > 90000) return "Heavy conversions (video, embroidery, CAD) can take several minutes — keep this tab open…";
  if (ms > 12000) return "Still processing — large files can take a minute…";
  return "";
}
